import React from "react";

interface KonnectLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

/**
 * Konnect xD Logo Component
 *
 * Official SVG logo component for the Konnect xD platform
 * Converted from original SVG file: 05abf570c4d5c342db7fecb4ba31fe35286ef37c.svg
 */
const KonnectLogo: React.FC<KonnectLogoProps> = ({
  width = 125,
  height = 17,
  className = "",
}) => {
  return (
    <svg
      preserveAspectRatio="none"
      width={width}
      height={height}
      viewBox="0 0 125 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: "block" }}
    >
      <g id="Konnect xD">
        {/* K */}
        <path
          d="M12.872 16.1538H8.73294L3.63872 8.67692V16.1538H0V0H3.63872V7.01538L8.50551 0H12.6446L7.27745 7.86923L12.872 16.1538Z"
          fill="#28154A"
        />

        {/* o */}
        <path
          d="M23.0617 14.7231C21.8942 15.8923 20.4691 16.4769 18.7862 16.4769C17.1032 16.4769 15.6781 15.8923 14.5107 14.7231C13.3432 13.5385 12.7595 12.0923 12.7595 10.3846C12.7595 8.67692 13.3432 7.23846 14.5107 6.06923C15.6781 4.88462 17.1032 4.29231 18.7862 4.29231C20.4691 4.29231 21.8942 4.88462 23.0617 6.06923C24.2291 7.23846 24.8128 8.67692 24.8128 10.3846C24.8128 12.0923 24.2291 13.5385 23.0617 14.7231ZM16.9213 12.3462C17.4216 12.8538 18.0432 13.1077 18.7862 13.1077C19.5291 13.1077 20.1507 12.8538 20.651 12.3462C21.1513 11.8385 21.4015 11.1846 21.4015 10.3846C21.4015 9.58461 21.1513 8.93077 20.651 8.42308C20.1507 7.91538 19.5291 7.66154 18.7862 7.66154C18.0432 7.66154 17.4216 7.91538 16.9213 8.42308C16.421 8.93077 16.1708 9.58461 16.1708 10.3846C16.1708 11.1846 16.421 11.8385 16.9213 12.3462Z"
          fill="#28154A"
        />

        {/* n */}
        <path
          d="M33.6331 4.29231C34.846 4.29231 35.8543 4.71539 36.6578 5.56154C37.4765 6.40769 37.8859 7.57692 37.8859 9.06923V16.1538H34.4746V9.57692C34.4746 8.9 34.2851 8.38462 33.906 8.03077C33.5422 7.66154 33.0722 7.47692 32.496 7.47692C31.8441 7.47692 31.3286 7.67692 30.9496 8.07692C30.5705 8.47692 30.381 9.06923 30.381 9.85385V16.1538H26.9697V4.61539H30.381V5.7C31.0633 4.76154 32.1473 4.29231 33.6331 4.29231Z"
          fill="#28154A"
        />

        {/* n */}
        <path
          d="M47.1193 4.29231C48.3322 4.29231 49.3405 4.71539 50.144 5.56154C50.9627 6.40769 51.3721 7.57692 51.3721 9.06923V16.1538H47.9608V9.57692C47.9608 8.9 47.7713 8.38462 47.3922 8.03077C47.0284 7.66154 46.5584 7.47692 45.9822 7.47692C45.3303 7.47692 44.8148 7.67692 44.4358 8.07692C44.0567 8.47692 43.8672 9.06923 43.8672 9.85385V16.1538H40.4559V4.61539H43.8672V5.7C44.5495 4.76154 45.6335 4.29231 47.1193 4.29231Z"
          fill="#28154A"
        />

        {/* e */}
        <path
          d="M56.9895 11.7692C57.3837 12.8462 58.2934 13.3846 59.7186 13.3846C60.6434 13.3846 61.3712 13.0923 61.9018 12.5077L64.6309 14.1C63.5089 15.6846 61.8563 16.4769 59.6731 16.4769C57.7628 16.4769 56.2315 15.9 55.0792 14.7462C53.9421 13.5923 53.3736 12.1385 53.3736 10.3846C53.3736 8.64615 53.9345 7.2 55.0565 6.04615C56.1936 4.87692 57.6491 4.29231 59.4229 4.29231C61.0755 4.29231 62.4476 4.87692 63.5392 6.04615C64.646 7.2 65.1994 8.64615 65.1994 10.3846C65.1994 10.8769 65.1539 11.3385 65.063 11.7692H56.9895ZM56.9213 9.18462H61.8109C61.4773 7.96923 60.6738 7.36154 59.4002 7.36154C58.0812 7.36154 57.2549 7.96923 56.9213 9.18462Z"
          fill="#28154A"
        />

        {/* c */}
        <path
          d="M72.7087 16.4769C70.9803 16.4769 69.54 15.8923 68.3877 14.7231C67.2506 13.5538 66.6821 12.1077 66.6821 10.3846C66.6821 8.66154 67.2506 7.21538 68.3877 6.04615C69.54 4.87692 70.9803 4.29231 72.7087 4.29231C73.8003 4.29231 74.801 4.56154 75.7107 5.1C76.6355 5.63846 77.3481 6.35385 77.8484 7.24615L74.8692 9C74.4599 8.13846 73.7245 7.70769 72.6632 7.70769C71.9203 7.70769 71.3063 7.96154 70.8211 8.46923C70.336 8.96154 70.0934 9.6 70.0934 10.3846C70.0934 11.1692 70.336 11.8154 70.8211 12.3231C71.3063 12.8154 71.9203 13.0615 72.6632 13.0615C73.7397 13.0615 74.475 12.6308 74.8692 11.7692L77.8484 13.5C77.3481 14.4077 76.6431 15.1308 75.7334 15.6692C74.8237 16.2077 73.8155 16.4769 72.7087 16.4769Z"
          fill="#28154A"
        />

        {/* t */}
        <path
          d="M86.1121 7.93846H83.7697V12.0231C83.7697 12.4846 83.9516 12.7769 84.3155 12.9C84.6794 13.0231 85.2782 13.0615 86.1121 13.0154V16.1538C83.944 16.3846 82.4431 16.1769 81.6092 15.5308C80.7753 14.8692 80.3584 13.7 80.3584 12.0231V7.93846H78.539V4.61539H80.3584V2.42308L83.7697 1.38462V4.61539H86.1121V7.93846Z"
          fill="#28154A"
        />

        {/* xD - simplified gradient version */}
        <path
          d="M100.569 16.1538V15.9231L101.479 15.6923L94.3605 5.07692L93.2007 4.86923V4.61539H101.138V4.86923L100.251 5.07692L107.414 15.6923L108.552 15.9231V16.1538H100.569ZM95.7251 16.5C95.2551 16.5 94.8305 16.4 94.4515 16.2C94.0725 16.0154 93.7768 15.7538 93.5646 15.4154C93.3523 15.0615 93.2462 14.6692 93.2462 14.2385C93.2462 13.7615 93.3599 13.3615 93.5873 13.0385C93.8147 12.7 94.118 12.4462 94.497 12.2769C94.876 12.0923 95.2854 12 95.7251 12C96.0738 12 96.3922 12.0538 96.6802 12.1615C96.9683 12.2538 97.226 12.3923 97.4534 12.5769C97.6809 12.7615 97.8552 12.9769 97.9765 13.2231C98.0978 13.4692 98.1585 13.7308 98.1585 14.0077C98.1585 14.1308 98.1433 14.2538 98.113 14.3769C98.0978 14.5 98.0751 14.6077 98.0448 14.7C98.0144 14.7923 97.9993 14.8692 97.9993 14.9308C97.9993 15.0385 98.0372 15.0923 98.113 15.0923C98.2039 15.0923 98.3177 14.9846 98.4541 14.7692C98.6057 14.5538 98.7649 14.2462 98.9317 13.8462C99.0985 13.4462 99.2577 12.9846 99.4093 12.4615L99.7504 12.9923H99.523C99.2804 13.7462 98.9848 14.3846 98.636 14.9077C98.3025 15.4308 97.8931 15.8308 97.408 16.1077C96.938 16.3692 96.377 16.5 95.7251 16.5ZM105.982 8.67692C105.603 8.67692 105.239 8.60769 104.89 8.46923C104.557 8.31538 104.284 8.1 104.071 7.82308C103.859 7.54615 103.753 7.21539 103.753 6.83077C103.753 6.64615 103.791 6.46923 103.867 6.3C103.958 6.11538 104.041 5.95385 104.117 5.81539C104.193 5.66154 104.231 5.54615 104.231 5.46923C104.231 5.37692 104.193 5.33077 104.117 5.33077C103.92 5.33077 103.708 5.49231 103.48 5.81539C103.268 6.12308 103.063 6.50769 102.866 6.96923C102.669 7.41538 102.495 7.83846 102.343 8.23846L102.025 7.75385H102.252C102.586 6.89231 102.927 6.20769 103.275 5.7C103.639 5.19231 104.026 4.83077 104.435 4.61539C104.86 4.38462 105.337 4.26923 105.868 4.26923C106.399 4.26923 106.853 4.37692 107.233 4.59231C107.612 4.79231 107.9 5.05385 108.097 5.37692C108.309 5.7 108.415 6.05385 108.415 6.43846C108.415 6.96154 108.294 7.39231 108.051 7.73077C107.824 8.05385 107.521 8.29231 107.142 8.44615C106.778 8.6 106.391 8.67692 105.982 8.67692Z"
          fill="url(#xdGradient)"
        />

        {/* D */}
        <path
          d="M116.772 0C118.971 0 120.805 0.776923 122.276 2.33077C123.762 3.86923 124.505 5.78462 124.505 8.07692C124.505 10.3692 123.762 12.2923 122.276 13.8462C120.805 15.3846 118.971 16.1538 116.772 16.1538H110.405V0H116.772ZM116.772 12.6C118.031 12.6 119.046 12.1923 119.82 11.3769C120.608 10.5462 121.002 9.44615 121.002 8.07692C121.002 6.70769 120.608 5.61539 119.82 4.8C119.046 3.96923 118.031 3.55385 116.772 3.55385H114.043V12.6H116.772Z"
          fill="url(#xdGradient)"
        />
      </g>

      <defs>
        {/* Simplified blue gradient for xD letters */}
        <linearGradient id="xdGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#002366" />
          <stop offset="25%" stopColor="#2A4A87" />
          <stop offset="50%" stopColor="#274D93" />
          <stop offset="75%" stopColor="#305191" />
          <stop offset="100%" stopColor="#002366" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default KonnectLogo;
